import type { AlertScopeKind } from '@chukua/common';
import { Form, Select, type FormInstance } from 'antd';
import { TruckSearchMultiSelect } from '../../fleet/features/trucks/public/TruckSearchMultiSelect';
import { useTruckClassOptions } from '../hooks/use-truck-class-options';
import { ALERT_SCOPE_LABELS, toOptions } from '../policies/alert-labels';
import type { AlertRuleFormValues } from '../policies/alert-rule-form';

const PICKER_COPY: Record<Exclude<AlertScopeKind, 'company'>, { label: string; extra?: string }> = {
  truck_class: { label: 'Truck classes' },
  unit: { label: 'Units', extra: 'A unit is a truck and the trailer it pulls, named by the truck.' },
};

/** "Applies to": the whole company, or a list picked from truck classes or units. Changing the kind clears the list, which would mean something else. */
export function AlertRuleScopeFields({ form }: { form: FormInstance<AlertRuleFormValues> }) {
  const scopeKind = Form.useWatch('scopeKind', form);
  const classes = useTruckClassOptions();

  return (
    <>
      <Form.Item
        name="scopeKind"
        label="Applies to"
        extra={scopeKind === 'company' ? 'Every truck, unless a narrower rule of the same kind covers it.' : undefined}
      >
        <Select options={toOptions(ALERT_SCOPE_LABELS)} onChange={() => form.setFieldValue('scopeValues', [])} />
      </Form.Item>
      {scopeKind !== undefined && scopeKind !== 'company' && (
        <Form.Item
          name="scopeValues"
          label={PICKER_COPY[scopeKind].label}
          extra={PICKER_COPY[scopeKind].extra}
          rules={[{ required: true, type: 'array', min: 1, message: `Pick at least one` }]}
        >
          {scopeKind === 'truck_class' && (
            <Select mode="multiple" placeholder="Select or search truck classes" options={classes ?? []} loading={classes === null} optionFilterProp="label" />
          )}
          {scopeKind === 'unit' && <TruckSearchMultiSelect />}
        </Form.Item>
      )}
    </>
  );
}
